import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SetDefaultStyleDto, DefaultStylesDto, ModelDto, ModelElementType } from '@maporium-workspace/shared';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DefaultStyleResource {
  private readonly baseUrl = environment.apiUrl + '/models';

  constructor(private http: HttpClient) {}

  getUserDefaultStyles(): Observable<DefaultStylesDto> {
    return this.http.get<DefaultStylesDto>(`${this.baseUrl}/defaults`);
  }

  setDefaultStyle(elementType: ModelElementType, elementId?: string, mapId?: string): Observable<ModelDto> {
    const type = elementType.toLowerCase();
    const dto = { elementId, mapId };
    return this.http.post<ModelDto>(`${this.baseUrl}/${type}/default`, dto);
  }

  resetDefaultStyles(): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.baseUrl}/defaults`);
  }

  resetDefaultStyle(elementType: ModelElementType): Observable<{ message: string }> {
    const type = elementType.toLowerCase();
    return this.http.delete<{ message: string }>(`${this.baseUrl}/${type}/default`);
  }

  getDefaultStyle(elementType: ModelElementType): Observable<ModelDto | null> {
    const type = elementType.toLowerCase();
    return this.http.get<ModelDto | null>(`${this.baseUrl}/${type}/default`);
  }
}